// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
//   Alert,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./TatRuleManagementPage.css";

// const SCOPE_TYPES = ["GLOBAL", "DEPARTMENT", "PROJECT", "PROJECT_MODULE", "TASK_TYPE_PRIORITY"];
// const TAT_UNITS = ["minutes", "hours", "days"];
// const REOPEN_POLICIES = ["KEEP_EXISTING_DUE_AT", "RESET_FROM_REOPEN", "ADD_ORIGINAL_TAT", "REQUIRE_MANUAL_TAT"];
// const PRIORITY_VALUES = ["low", "normal", "high"];

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   scope_type: "GLOBAL",
//   department_id: "",
//   project_id: "",
//   project_module_id: "",
//   task_type_id: "",
//   priority: "",
//   tat_value: "",
//   tat_unit: "hours",
//   reopen_policy: "KEEP_EXISTING_DUE_AT",
//   requires_change_approval: false,
//   can_override_it_subcategory: false,
//   priority_order: "",
// };

// const initialPreviewContext = {
//   task_type_id: "",
//   priority: "",
//   department_id: "",
//   project_id: "",
//   project_module_id: "",
//   sub_category_id: "",
// };

// export default function TatRuleManagementPage() {
//   const { can } = usePermissions();

//   const [rules, setRules] = useState([]);
//   const [total, setTotal] = useState(0);

//   const [taskTypes, setTaskTypes] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [projectModules, setProjectModules] = useState([]);
//   const [loadingScopeTargets, setLoadingScopeTargets] = useState(false);

//   const [search, setSearch] = useState("");
//   const [scopeTypeFilter, setScopeTypeFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");

//   const [sortField, setSortField] = useState("priority_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   // Resolution preview
//   const [previewContext, setPreviewContext] = useState(initialPreviewContext);
//   const [previewResult, setPreviewResult] = useState(null);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   useEffect(() => {
//     fetchRules();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, scopeTypeFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

//   useEffect(() => {
//     fetchScopeReferenceData();
//   }, []);

//   const fetchScopeReferenceData = async () => {
//     try {
//       const [typeRes, deptRes, projectRes] = await Promise.all([
//         api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }),
//         api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),
//         api.get("/projects", { params: { is_active: 1, pageSize: 200 } }),
//       ]);
//       setTaskTypes(Array.isArray(typeRes.data?.data) ? typeRes.data.data : []);
//       setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);
//       setProjects(Array.isArray(projectRes.data?.data) ? projectRes.data.data : []);
//     } catch (err) {
//       console.error("Fetch TAT rule scope reference data error:", err);
//     }
//   };

//   const fetchProjectModules = async (projectId) => {
//     if (!projectId) {
//       setProjectModules([]);
//       return;
//     }
//     try {
//       setLoadingScopeTargets(true);
//       const res = await api.get(`/projects/${projectId}/modules`, { params: { is_active: 1, pageSize: 200 } });
//       setProjectModules(Array.isArray(res.data?.data) ? res.data.data : []);
//     } catch (err) {
//       console.error("Fetch project modules error:", err);
//       setProjectModules([]);
//     } finally {
//       setLoadingScopeTargets(false);
//     }
//   };

//   const fetchRules = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/tat-rules", {
//         params: {
//           search: search || undefined,
//           scope_type: scopeTypeFilter || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setRules(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch TAT rules error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch TAT rules");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const handleScopeTypeChange = (scopeType) => {
//     setForm((prev) => ({
//       ...prev,
//       scope_type: scopeType,
//       department_id: "",
//       project_id: "",
//       project_module_id: "",
//       task_type_id: scopeType === "TASK_TYPE_PRIORITY" ? prev.task_type_id : "",
//       priority: scopeType === "TASK_TYPE_PRIORITY" ? prev.priority : "",
//     }));
//     if (scopeType === "PROJECT_MODULE") setProjectModules([]);
//   };

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setShowModal(true);
//   };

//   const openEdit = (rule) => {
//     setForm({
//       name: rule.name || "",
//       code: rule.code || "",
//       description: rule.description || "",
//       scope_type: rule.scope_type || "GLOBAL",
//       department_id: rule.department_id ?? "",
//       project_id: rule.project_id ?? "",
//       project_module_id: rule.project_module_id ?? "",
//       task_type_id: rule.task_type_id ?? "",
//       priority: rule.priority || "",
//       tat_value: rule.tat_value ?? "",
//       tat_unit: rule.tat_unit || "hours",
//       reopen_policy: rule.reopen_policy || "KEEP_EXISTING_DUE_AT",
//       requires_change_approval: !!rule.requires_change_approval,
//       can_override_it_subcategory: !!rule.can_override_it_subcategory,
//       priority_order: rule.priority_order ?? "",
//     });
//     setEditId(rule.id);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Rule name is required");
//       return;
//     }
//     if (!form.tat_value || Number(form.tat_value) <= 0) {
//       toast.warning("TAT value must be a positive number");
//       return;
//     }
//     if (form.scope_type !== "GLOBAL") {
//       if (form.scope_type === "DEPARTMENT" && !form.department_id) {
//         toast.warning("Please select a department");
//         return;
//       }
//       if ((form.scope_type === "PROJECT" || form.scope_type === "PROJECT_MODULE") && !form.project_id) {
//         toast.warning("Please select a project");
//         return;
//       }
//       if (form.scope_type === "PROJECT_MODULE" && !form.project_module_id) {
//         toast.warning("Please select a project module");
//         return;
//       }
//       if (form.scope_type === "TASK_TYPE_PRIORITY" && !form.task_type_id) {
//         toast.warning("Please select a task type");
//         return;
//       }
//     }

//     const payload = {
//       name: form.name.trim(),
//       description: form.description.trim() || null,
//       scope_type: form.scope_type,
//       department_id: form.scope_type === "DEPARTMENT" ? Number(form.department_id) : null,
//       project_id: (form.scope_type === "PROJECT" || form.scope_type === "PROJECT_MODULE") ? Number(form.project_id) : null,
//       project_module_id: form.scope_type === "PROJECT_MODULE" ? Number(form.project_module_id) : null,
//       task_type_id: form.scope_type === "TASK_TYPE_PRIORITY" ? Number(form.task_type_id) : null,
//       priority: form.scope_type === "TASK_TYPE_PRIORITY" && form.priority ? form.priority : null,
//       tat_value: Number(form.tat_value),
//       tat_unit: form.tat_unit,
//       reopen_policy: form.reopen_policy,
//       requires_change_approval: form.requires_change_approval,
//       can_override_it_subcategory: form.can_override_it_subcategory,
//       priority_order: form.priority_order === "" ? 0 : Number(form.priority_order),
//     };

//     if (!editId) {
//       payload.code = form.code.trim() || undefined;
//     }

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/tat-rules/${editId}`, payload);
//         toast.success("TAT rule updated");
//       } else {
//         await api.post("/tat-rules", payload);
//         toast.success("TAT rule created");
//       }
//       closeModal();
//       fetchRules();
//     } catch (err) {
//       console.error("Save TAT rule error:", err);
//       const data = err.response?.data;
//       if (data?.code === "TAT_RULE_SCOPE_CONFLICT") {
//         toast.error("An active rule already exists for this exact scope combination.");
//       } else {
//         toast.error(data?.message || "Failed to save TAT rule");
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (rule) => {
//     try {
//       await api.patch(`/tat-rules/${rule.id}/status`, { is_active: !rule.is_active });
//       toast.success(rule.is_active ? "Rule deactivated" : "Rule activated");
//       fetchRules();
//     } catch (err) {
//       console.error("Toggle rule status error:", err);
//       const data = err.response?.data;
//       if (data?.code === "TAT_RULE_SCOPE_CONFLICT") {
//         toast.error("An active rule already exists for this exact scope combination.");
//       } else {
//         toast.error(data?.message || "Failed to update status");
//       }
//     }
//   };

//   const openDeleteModal = (rule) => {
//     setDeleteTarget(rule);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/tat-rules/${deleteTarget.id}`);
//       toast.success("TAT rule deleted");
//       closeDeleteModal();
//       fetchRules();
//     } catch (err) {
//       console.error("Delete TAT rule error:", err);
//       const data = err.response?.data;
//       if (data?.code === "TAT_RULE_IN_USE") {
//         const d = data.details?.dependents;
//         toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}). Deactivate instead.`);
//       } else {
//         toast.error(data?.message || "Failed to delete TAT rule");
//       }
//       closeDeleteModal();
//     }
//   };

//   const scopeTargetLabel = (rule) => {
//     if (rule.scope_type === "GLOBAL") return "—";
//     if (rule.scope_type === "DEPARTMENT") return rule.department_name || `#${rule.department_id}`;
//     if (rule.scope_type === "PROJECT") return rule.project_name || `#${rule.project_id}`;
//     if (rule.scope_type === "PROJECT_MODULE") return `${rule.project_name || rule.project_id} / ${rule.project_module_name || rule.project_module_id}`;
//     if (rule.scope_type === "TASK_TYPE_PRIORITY") return `${rule.task_type_name || rule.task_type_id}${rule.priority ? ` (${rule.priority})` : ""}`;
//     return "—";
//   };

//   const runPreview = async () => {
//     try {
//       setPreviewLoading(true);
//       setPreviewResult(null);
//       const payload = {};
//       Object.entries(previewContext).forEach(([key, value]) => {
//         if (value !== "") payload[key] = value;
//       });
//       const res = await api.post("/tat-rules/preview", payload);
//       setPreviewResult(res.data?.data || null);
//     } catch (err) {
//       console.error("Preview TAT resolution error:", err);
//       toast.error(err.response?.data?.message || "Failed to preview TAT resolution");
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   return (
//     <div className="unit-page tatrule-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>TAT Rule Management</h2>
//           <p>Configure turnaround-time rules for departments, projects, modules and task type/priority combinations.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchRules}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="tat_rules" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add TAT Rule
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="tatrule-stat-icon tatrule-stat-icon-primary">
//             <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
//           </div>
//           <div className="tatrule-stat-text">
//             <span>Total Rules</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="tatrule-stat-icon tatrule-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="tatrule-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-list-check tatrule-list-icon" aria-hidden="true"></i>
//               Rule List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete TAT rules.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 240 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search TAT rule name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 190 }}
//               value={scopeTypeFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setScopeTypeFilter(e.target.value);
//               }}
//             >
//               <option value="">All Scope Types</option>
//               {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading TAT rules...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("scope_type")}>Scope {sortIcon("scope_type")}</th>
//                   <th>Target</th>
//                   <th>TAT</th>
//                   <th>Reopen Policy</th>
//                   <th>Flags</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {rules.length > 0 ? (
//                   rules.map((rule) => (
//                     <tr key={rule.id}>
//                       <td>
//                         <strong>{rule.name}</strong>
//                         <br />
//                         <small className="text-muted">{rule.code}</small>
//                       </td>
//                       <td><Badge bg="light" text="dark">{rule.scope_type}</Badge></td>
//                       <td>{scopeTargetLabel(rule)}</td>
//                       <td>{rule.tat_value} {rule.tat_unit}</td>
//                       <td><small>{rule.reopen_policy}</small></td>
//                       <td>
//                         {!!rule.requires_change_approval && <Badge bg="warning" text="dark" className="me-1 mb-1">Needs Approval</Badge>}
//                         {!!rule.can_override_it_subcategory && <Badge bg="info" className="me-1 mb-1">Can Override IT</Badge>}
//                       </td>
//                       <td>
//                         <Badge className={`unit-status${rule.is_active ? "" : " unit-status-inactive"}`}>
//                           {rule.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="tat_rules" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${rule.name || "TAT rule"}`}
//                               onClick={() => openEdit(rule)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("tat_rules", "activate") || can("tat_rules", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn tatrule-toggle"
//                               title={rule.is_active ? "Deactivate" : "Activate"}
//                               aria-label={`${rule.is_active ? "Deactivate" : "Activate"} ${rule.name || "TAT rule"}`}
//                               onClick={() => toggleStatus(rule)}
//                             >
//                               <i className={`fa-solid ${rule.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="tat_rules" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete ${rule.name || "TAT rule"}`}
//                               onClick={() => openDeleteModal(rule)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="8">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
//                         </div>
//                         <h5>No TAT rules found</h5>
//                         <p>Try another search or add a new rule.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{rules.length}</strong> of <strong>{total}</strong> rules
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Can moduleKey="tat_rules" actionKey="preview_resolution">
//         <div className="unit-card mt-4">
//           <div className="unit-toolbar">
//             <div>
//               <h5>Resolution Preview</h5>
//               <p>Pick a task context and see which rule would apply, its source, and the estimated due date. Read-only — nothing is saved.</p>
//             </div>
//           </div>

//           <div className="row g-3 px-3 pb-3">
//             <div className="col-md-3">
//               <Form.Label>Task Type</Form.Label>
//               <Form.Select value={previewContext.task_type_id} onChange={(e) => setPreviewContext((p) => ({ ...p, task_type_id: e.target.value }))}>
//                 <option value="">Not set</option>
//                 {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Priority</Form.Label>
//               <Form.Select value={previewContext.priority} onChange={(e) => setPreviewContext((p) => ({ ...p, priority: e.target.value }))}>
//                 <option value="">Not set</option>
//                 {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Department</Form.Label>
//               <Form.Select value={previewContext.department_id} onChange={(e) => setPreviewContext((p) => ({ ...p, department_id: e.target.value }))}>
//                 <option value="">Not set</option>
//                 {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Project</Form.Label>
//               <Form.Select
//                 value={previewContext.project_id}
//                 onChange={(e) => {
//                   setPreviewContext((p) => ({ ...p, project_id: e.target.value, project_module_id: "" }));
//                   fetchProjectModules(e.target.value);
//                 }}
//               >
//                 <option value="">Not set</option>
//                 {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Project Module</Form.Label>
//               <Form.Select
//                 value={previewContext.project_module_id}
//                 onChange={(e) => setPreviewContext((p) => ({ ...p, project_module_id: e.target.value }))}
//                 disabled={loadingScopeTargets || !previewContext.project_id}
//               >
//                 <option value="">Not set</option>
//                 {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3 d-flex align-items-end">
//               <Button className="unit-btn unit-btn-primary w-100" onClick={runPreview} disabled={previewLoading}>
//                 {previewLoading ? "Resolving..." : "Preview Resolution"}
//               </Button>
//             </div>
//           </div>

//           {previewResult && (
//             <div className="px-3 pb-3">
//               {previewResult.source ? (
//                 <Alert variant="success">
//                   <strong>Source:</strong> {previewResult.source}
//                   {previewResult.source_rule_id && <> (rule #{previewResult.source_rule_id})</>}
//                   <br />
//                   <strong>Applied TAT:</strong> {previewResult.tat_value} {previewResult.tat_unit}
//                   <br />
//                   <strong>Estimated due date:</strong> {previewResult.due_at}
//                 </Alert>
//               ) : (
//                 <Alert variant="warning">No TAT rule could be resolved for this context — the task would get no due date.</Alert>
//               )}
//               {Array.isArray(previewResult.explanation) && previewResult.explanation.length > 0 && (
//                 <div className="unit-card" style={{ padding: 12 }}>
//                   <strong>Why:</strong>
//                   <ul className="mb-0">
//                     {previewResult.explanation.map((line, i) => <li key={i}><small>{line}</small></li>)}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </Can>

//       <Modal show={showModal} onHide={closeModal} centered className="unit-modal" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{editId ? "Edit TAT Rule" : "Add New TAT Rule"}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Project X Fast Track"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
//               <Form.Control
//                 placeholder="e.g. PROJECT_X_FAST_TRACK"
//                 value={form.code}
//                 disabled={!!editId}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Scope Type</Form.Label>
//               <Form.Select value={form.scope_type} onChange={(e) => handleScopeTypeChange(e.target.value)}>
//                 {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}
//               </Form.Select>
//             </div>

//             {form.scope_type === "DEPARTMENT" && (
//               <div className="col-md-8">
//                 <Form.Label>Department</Form.Label>
//                 <Form.Select value={form.department_id} onChange={(e) => handleChange("department_id", e.target.value)}>
//                   <option value="">Select department...</option>
//                   {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
//                 </Form.Select>
//               </div>
//             )}

//             {form.scope_type === "PROJECT" && (
//               <div className="col-md-8">
//                 <Form.Label>Project</Form.Label>
//                 <Form.Select value={form.project_id} onChange={(e) => handleChange("project_id", e.target.value)}>
//                   <option value="">Select project...</option>
//                   {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//                 </Form.Select>
//               </div>
//             )}

//             {form.scope_type === "PROJECT_MODULE" && (
//               <>
//                 <div className="col-md-4">
//                   <Form.Label>Project</Form.Label>
//                   <Form.Select
//                     value={form.project_id}
//                     onChange={(e) => {
//                       handleChange("project_id", e.target.value);
//                       handleChange("project_module_id", "");
//                       fetchProjectModules(e.target.value);
//                     }}
//                   >
//                     <option value="">Select project...</option>
//                     {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//                   </Form.Select>
//                 </div>
//                 <div className="col-md-4">
//                   <Form.Label>Module</Form.Label>
//                   <Form.Select
//                     value={form.project_module_id}
//                     onChange={(e) => handleChange("project_module_id", e.target.value)}
//                     disabled={loadingScopeTargets || !form.project_id}
//                   >
//                     <option value="">Select module...</option>
//                     {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
//                   </Form.Select>
//                 </div>
//               </>
//             )}

//             {form.scope_type === "TASK_TYPE_PRIORITY" && (
//               <>
//                 <div className="col-md-4">
//                   <Form.Label>Task Type</Form.Label>
//                   <Form.Select value={form.task_type_id} onChange={(e) => handleChange("task_type_id", e.target.value)}>
//                     <option value="">Select task type...</option>
//                     {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//                   </Form.Select>
//                 </div>
//                 <div className="col-md-4">
//                   <Form.Label>Priority (optional narrowing)</Form.Label>
//                   <Form.Select value={form.priority} onChange={(e) => handleChange("priority", e.target.value)}>
//                     <option value="">Applies to all priorities</option>
//                     {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}
//                   </Form.Select>
//                 </div>
//               </>
//             )}

//             <div className="col-md-3">
//               <Form.Label>TAT Value</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.tat_value}
//                 onChange={(e) => handleChange("tat_value", e.target.value)}
//               />
//             </div>
//             <div className="col-md-3">
//               <Form.Label>TAT Unit</Form.Label>
//               <Form.Select value={form.tat_unit} onChange={(e) => handleChange("tat_unit", e.target.value)}>
//                 {TAT_UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Reopen Policy</Form.Label>
//               <Form.Select value={form.reopen_policy} onChange={(e) => handleChange("reopen_policy", e.target.value)}>
//                 {REOPEN_POLICIES.map((p) => <option key={p} value={p}>{p}</option>)}
//               </Form.Select>
//             </div>
//             <div className="col-md-3">
//               <Form.Label>Priority (tie-break)</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.priority_order}
//                 onChange={(e) => handleChange("priority_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Check
//                 type="checkbox"
//                 label="Requires approval before a requested TAT change takes effect"
//                 checked={form.requires_change_approval}
//                 onChange={(e) => handleChange("requires_change_approval", e.target.checked)}
//               />
//               <Form.Check
//                 type="checkbox"
//                 label="Can override the IT-support sub-category TAT baseline"
//                 checked={form.can_override_it_subcategory}
//                 onChange={(e) => handleChange("can_override_it_subcategory", e.target.checked)}
//               />
//               {form.can_override_it_subcategory && (
//                 <Form.Text className="text-danger">
//                   Warning: this rule will take precedence over the existing IT sub-category TAT for matching IT-support tasks.
//                 </Form.Text>
//               )}
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Rule" : "Create Rule"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showDeleteModal} onHide={closeDeleteModal} centered className="unit-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete TAT Rule</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If tasks or history reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }








import React, { useEffect, useState } from "react";

import { compactPageItems } from "../../components/ui/compactPagination";
import {

  Table,

  Button,

  Form,

  Modal,

  InputGroup,

  Pagination,

  Badge,

  Spinner,

  Alert,

} from "react-bootstrap";

import api from "../../api";

import Can from "../../components/Can";

import { usePermissions } from "../../context/PermissionContext";

import { toast } from "react-toastify";


import "./TatRuleManagementPage.css";

const SCOPE_TYPES = ["GLOBAL", "DEPARTMENT", "PROJECT", "PROJECT_MODULE", "TASK_TYPE_PRIORITY"];

const TAT_UNITS = ["minutes", "hours", "days"];

const REOPEN_POLICIES = ["KEEP_EXISTING_DUE_AT", "RESET_FROM_REOPEN", "ADD_ORIGINAL_TAT", "REQUIRE_MANUAL_TAT"];

const PRIORITY_VALUES = ["low", "normal", "high"];

const initialForm = {

  name: "",

  code: "",

  description: "",

  scope_type: "GLOBAL",

  department_id: "",

  project_id: "",

  project_module_id: "",

  task_type_id: "",

  priority: "",

  tat_value: "",

  tat_unit: "hours",

  reopen_policy: "KEEP_EXISTING_DUE_AT",

  requires_change_approval: false,

  can_override_it_subcategory: false,

  priority_order: "",

};

const initialPreviewContext = {

  task_type_id: "",

  priority: "",

  department_id: "",

  project_id: "",

  project_module_id: "",

  sub_category_id: "",

};

export default function TatRuleManagementPage() {

  const { can } = usePermissions();

  const [rules, setRules] = useState([]);

  const [total, setTotal] = useState(0);

  const [taskTypes, setTaskTypes] = useState([]);

  const [departments, setDepartments] = useState([]);

  const [projects, setProjects] = useState([]);

  const [projectModules, setProjectModules] = useState([]);

  const [loadingScopeTargets, setLoadingScopeTargets] = useState(false);

  const [search, setSearch] = useState("");

  const [scopeTypeFilter, setScopeTypeFilter] = useState("");

  const [statusFilter, setStatusFilter] = useState("");

  const [sortField, setSortField] = useState("priority_order");

  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);

  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);

  const [editId, setEditId] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Resolution preview

  const [previewContext, setPreviewContext] = useState(initialPreviewContext);

  const [previewResult, setPreviewResult] = useState(null);

  const [previewLoading, setPreviewLoading] = useState(false);

  useEffect(() => {

    fetchRules();

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [search, scopeTypeFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

  useEffect(() => {

    fetchScopeReferenceData();

  }, []);

  const fetchScopeReferenceData = async () => {

    try {

      const [typeRes, deptRes, projectRes] = await Promise.all([

        api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }),

        api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),

        api.get("/projects", { params: { is_active: 1, pageSize: 200 } }),

      ]);

      setTaskTypes(Array.isArray(typeRes.data?.data) ? typeRes.data.data : []);

      setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);

      setProjects(Array.isArray(projectRes.data?.data) ? projectRes.data.data : []);

    } catch (err) {

      console.error("Fetch TAT rule scope reference data error:", err);

    }

  };

  const fetchProjectModules = async (projectId) => {

    if (!projectId) {

      setProjectModules([]);

      return;

    }

    try {

      setLoadingScopeTargets(true);

      const res = await api.get(`/projects/${projectId}/modules`, { params: { is_active: 1, pageSize: 200 } });

      setProjectModules(Array.isArray(res.data?.data) ? res.data.data : []);

    } catch (err) {

      console.error("Fetch project modules error:", err);

      setProjectModules([]);

    } finally {

      setLoadingScopeTargets(false);

    }

  };

  const fetchRules = async () => {

    try {

      setLoading(true);

      const res = await api.get("/tat-rules", {

        params: {

          search: search || undefined,

          scope_type: scopeTypeFilter || undefined,

          is_active: statusFilter === "" ? undefined : statusFilter,

          sortField,

          sortOrder,

          page: currentPage,

          pageSize,

        },

      });

      setRules(Array.isArray(res.data?.data) ? res.data.data : []);

      setTotal(res.data?.meta?.total || 0);

    } catch (err) {

      console.error("Fetch TAT rules error:", err);

      toast.error(err.response?.data?.message || "Failed to fetch TAT rules");

    } finally {

      setLoading(false);

    }

  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {

    if (sortField === field) {

      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));

    } else {

      setSortField(field);

      setSortOrder("asc");

    }

  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleScopeTypeChange = (scopeType) => {

    setForm((prev) => ({

      ...prev,

      scope_type: scopeType,

      department_id: "",

      project_id: "",

      project_module_id: "",

      task_type_id: scopeType === "TASK_TYPE_PRIORITY" ? prev.task_type_id : "",

      priority: scopeType === "TASK_TYPE_PRIORITY" ? prev.priority : "",

    }));

    if (scopeType === "PROJECT_MODULE") setProjectModules([]);

  };

  const openAdd = () => {

    setForm(initialForm);

    setEditId(null);

    setShowModal(true);

  };

  const openEdit = (rule) => {

    setForm({

      name: rule.name || "",

      code: rule.code || "",

      description: rule.description || "",

      scope_type: rule.scope_type || "GLOBAL",

      department_id: rule.department_id ?? "",

      project_id: rule.project_id ?? "",

      project_module_id: rule.project_module_id ?? "",

      task_type_id: rule.task_type_id ?? "",

      priority: rule.priority || "",

      tat_value: rule.tat_value ?? "",

      tat_unit: rule.tat_unit || "hours",

      reopen_policy: rule.reopen_policy || "KEEP_EXISTING_DUE_AT",

      requires_change_approval: !!rule.requires_change_approval,

      can_override_it_subcategory: !!rule.can_override_it_subcategory,

      priority_order: rule.priority_order ?? "",

    });

    setEditId(rule.id);

    setShowModal(true);

  };

  const closeModal = () => {

    setShowModal(false);

    setEditId(null);

    setForm(initialForm);

  };

  const handleSave = async () => {

    if (!form.name.trim()) {

      toast.warning("Rule name is required");

      return;

    }

    if (!form.tat_value || Number(form.tat_value) <= 0) {

      toast.warning("TAT value must be a positive number");

      return;

    }

    if (form.scope_type !== "GLOBAL") {

      if (form.scope_type === "DEPARTMENT" && !form.department_id) {

        toast.warning("Please select a department");

        return;

      }

      if ((form.scope_type === "PROJECT" || form.scope_type === "PROJECT_MODULE") && !form.project_id) {

        toast.warning("Please select a project");

        return;

      }

      if (form.scope_type === "PROJECT_MODULE" && !form.project_module_id) {

        toast.warning("Please select a project module");

        return;

      }

      if (form.scope_type === "TASK_TYPE_PRIORITY" && !form.task_type_id) {

        toast.warning("Please select a task type");

        return;

      }

    }

    const payload = {

      name: form.name.trim(),

      description: form.description.trim() || null,

      scope_type: form.scope_type,

      department_id: form.scope_type === "DEPARTMENT" ? Number(form.department_id) : null,

      project_id: (form.scope_type === "PROJECT" || form.scope_type === "PROJECT_MODULE") ? Number(form.project_id) : null,

      project_module_id: form.scope_type === "PROJECT_MODULE" ? Number(form.project_module_id) : null,

      task_type_id: form.scope_type === "TASK_TYPE_PRIORITY" ? Number(form.task_type_id) : null,

      priority: form.scope_type === "TASK_TYPE_PRIORITY" && form.priority ? form.priority : null,

      tat_value: Number(form.tat_value),

      tat_unit: form.tat_unit,

      reopen_policy: form.reopen_policy,

      requires_change_approval: form.requires_change_approval,

      can_override_it_subcategory: form.can_override_it_subcategory,

      priority_order: form.priority_order === "" ? 0 : Number(form.priority_order),

    };

    if (!editId) {

      payload.code = form.code.trim() || undefined;

    }

    try {

      setSaving(true);

      if (editId) {

        await api.put(`/tat-rules/${editId}`, payload);

        toast.success("TAT rule updated");

      } else {

        await api.post("/tat-rules", payload);

        toast.success("TAT rule created");

      }

      closeModal();

      fetchRules();

    } catch (err) {

      console.error("Save TAT rule error:", err);

      const data = err.response?.data;

      if (data?.code === "TAT_RULE_SCOPE_CONFLICT") {

        toast.error("An active rule already exists for this exact scope combination.");

      } else {

        toast.error(data?.message || "Failed to save TAT rule");

      }

    } finally {

      setSaving(false);

    }

  };

  const toggleStatus = async (rule) => {

    try {

      await api.patch(`/tat-rules/${rule.id}/status`, { is_active: !rule.is_active });

      toast.success(rule.is_active ? "Rule deactivated" : "Rule activated");

      fetchRules();

    } catch (err) {

      console.error("Toggle rule status error:", err);

      const data = err.response?.data;

      if (data?.code === "TAT_RULE_SCOPE_CONFLICT") {

        toast.error("An active rule already exists for this exact scope combination.");

      } else {

        toast.error(data?.message || "Failed to update status");

      }

    }

  };

  const openDeleteModal = (rule) => {

    setDeleteTarget(rule);

    setShowDeleteModal(true);

  };

  const closeDeleteModal = () => {

    setDeleteTarget(null);

    setShowDeleteModal(false);

  };

  const confirmDelete = async () => {

    if (!deleteTarget) return;

    try {

      await api.delete(`/tat-rules/${deleteTarget.id}`);

      toast.success("TAT rule deleted");

      closeDeleteModal();

      fetchRules();

    } catch (err) {

      console.error("Delete TAT rule error:", err);

      const data = err.response?.data;

      if (data?.code === "TAT_RULE_IN_USE") {

        const d = data.details?.dependents;

        toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}). Deactivate instead.`);

      } else {

        toast.error(data?.message || "Failed to delete TAT rule");

      }

      closeDeleteModal();

    }

  };

  const scopeTargetLabel = (rule) => {

    if (rule.scope_type === "GLOBAL") return "—";

    if (rule.scope_type === "DEPARTMENT") return rule.department_name || `#${rule.department_id}`;

    if (rule.scope_type === "PROJECT") return rule.project_name || `#${rule.project_id}`;

    if (rule.scope_type === "PROJECT_MODULE") return `${rule.project_name || rule.project_id} / ${rule.project_module_name || rule.project_module_id}`;

    if (rule.scope_type === "TASK_TYPE_PRIORITY") return `${rule.task_type_name || rule.task_type_id}${rule.priority ? ` (${rule.priority})` : ""}`;

    return "—";

  };

  const runPreview = async () => {

    try {

      setPreviewLoading(true);

      setPreviewResult(null);

      const payload = {};

      Object.entries(previewContext).forEach(([key, value]) => {

        if (value !== "") payload[key] = value;

      });

      const res = await api.post("/tat-rules/preview", payload);

      setPreviewResult(res.data?.data || null);

    } catch (err) {

      console.error("Preview TAT resolution error:", err);

      toast.error(err.response?.data?.message || "Failed to preview TAT resolution");

    } finally {

      setPreviewLoading(false);

    }

  };

  return (

    <div className="unit-page tatrule-mgmt-theme">


      <div className="tatrule-heading-box">

        <div className="tatrule-heading-content">

          <div className="tatrule-heading-icon">
            <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
          </div>

          <div>

            <div className="unit-page-label">Configuration</div>

            <h2>TAT Rule Management</h2>

            <p>Configure turnaround-time rules for departments, projects, modules and task type/priority combinations.</p>

          </div>

        </div>

        <div className="unit-header-actions">

          <Button className="unit-btn unit-btn-light" onClick={fetchRules}>

            <i className="fa-solid fa-rotate" aria-hidden="true"></i>

            Refresh

          </Button>

          <Can moduleKey="tat_rules" actionKey="create">

            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>

              <i className="fa-solid fa-plus" aria-hidden="true"></i>

              Add TAT Rule

            </Button>

          </Can>

        </div>

      </div>

      <div className="unit-stats-row">

        <div className="unit-stat-card tatrule-stat-blue">

          <div className="tatrule-stat-content">

            <div className="tatrule-stat-text">

              <span>Total Rules</span>

              <strong>{total}</strong>

            </div>

            <div className="tatrule-stat-icon">
              <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
            </div>

          </div>

        </div>

        <div className="unit-stat-card tatrule-stat-purple">

          <div className="tatrule-stat-content">

            <div className="tatrule-stat-text">

              <span>Current Page</span>

              <strong>{currentPage}</strong>

            </div>

            <div className="tatrule-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>

          </div>

        </div>

        <div className="unit-stat-card tatrule-stat-green">

          <div className="tatrule-stat-content">

            <div className="tatrule-stat-text">

              <span>Rows Per Page</span>

              <strong>{pageSize}</strong>

            </div>

            <div className="tatrule-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

          </div>

        </div>

      </div>

      <div className="unit-card">

        <div className="unit-toolbar tatrule-toolbar">

          <div className="tatrule-section-title">

            <div className="tatrule-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="tatrule-section-copy">

              <h5>Rule List</h5>

              <p>Search, filter, add, update, activate/deactivate or delete TAT rules.</p>

            </div>

          </div>

          <div className="unit-toolbar-actions tatrule-filters-row">

            <InputGroup className="unit-search tatrule-search">

              <InputGroup.Text aria-hidden="true">

                <i className="fa-solid fa-magnifying-glass"></i>

              </InputGroup.Text>

              <Form.Control

                placeholder="Search name or code..."

                aria-label="Search TAT rule name or code"

                value={search}

                onChange={(e) => {

                  setCurrentPage(1);

                  setSearch(e.target.value);

                }}

              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}

            </InputGroup>

            <div className="tatrule-select-wrap">
              <i className="fa-solid fa-crosshairs tatrule-select-icon" aria-hidden="true"></i>

              <Form.Select
                className="tatrule-filter-select"
                value={scopeTypeFilter}

              onChange={(e) => {

                setCurrentPage(1);

                setScopeTypeFilter(e.target.value);

              }}

            >

              <option value="">All Scope Types</option>

                {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}

              </Form.Select>
            </div>

            <div className="tatrule-select-wrap">
              <i className="fa-solid fa-circle-check tatrule-select-icon" aria-hidden="true"></i>

              <Form.Select
                className="tatrule-filter-select"
                value={statusFilter}

              onChange={(e) => {

                setCurrentPage(1);

                setStatusFilter(e.target.value);

              }}

            >

              <option value="">All Statuses</option>

              <option value="1">Active</option>

                <option value="0">Inactive</option>

              </Form.Select>
            </div>

            <Form.Select

              className="unit-page-size"

              value={pageSize}

              onChange={(e) => {

                setCurrentPage(1);

                setPageSize(Number(e.target.value));

              }}

            >

              <option value={10}>10 rows</option>

              <option value={20}>20 rows</option>

              <option value={50}>50 rows</option>

            </Form.Select>

          </div>

        </div>

        <div className="unit-table-wrapper">

          {loading ? (

            <div className="unit-loader">

              <Spinner animation="border" />

              <p>Loading TAT rules...</p>

            </div>

          ) : (

            <Table responsive className="unit-table">

              <thead>

                <tr>

                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>

                  <th className="sortable" onClick={() => handleSort("scope_type")}>Scope {sortIcon("scope_type")}</th>

                  <th>Target</th>

                  <th>TAT</th>

                  <th>Reopen Policy</th>

                  <th>Flags</th>

                  <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>

                  <th className="text-end">Actions</th>

                </tr>

              </thead>

              <tbody>

                {rules.length > 0 ? (

                  rules.map((rule) => (

                    <tr key={rule.id}>

                      <td>

                        <div className="tatrule-name-box">

                          <div className="tatrule-letter">
                            {rule.name?.charAt(0)?.toUpperCase() || "T"}
                          </div>

                          <div className="tatrule-name-copy">

                            <strong title={rule.name}>{rule.name}</strong>

                            <small>{rule.code || `Rule #${rule.id}`}</small>

                          </div>

                        </div>

                      </td>

                      <td>
                        <span
                          className={`tatrule-scope-chip tatrule-scope-${String(
                            rule.scope_type || ""
                          ).toLowerCase()}`}
                        >
                          <i className="fa-solid fa-crosshairs" aria-hidden="true"></i>
                          {String(rule.scope_type || "").replaceAll("_", " ")}
                        </span>
                      </td>

                      <td>
                        <span className="tatrule-target-chip">
                          <i className="fa-solid fa-bullseye" aria-hidden="true"></i>
                          {scopeTargetLabel(rule)}
                        </span>
                      </td>

                      <td>
                        <span className="tatrule-time-chip">
                          <i className="fa-regular fa-clock" aria-hidden="true"></i>
                          {rule.tat_value} {rule.tat_unit}
                        </span>
                      </td>

                      <td>
                        <span className="tatrule-policy-chip">
                          <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                          {String(rule.reopen_policy || "").replaceAll("_", " ")}
                        </span>
                      </td>

                      <td>

                        <div className="tatrule-flags-wrap">

                          {!!rule.requires_change_approval && (
                            <span className="tatrule-flag-chip tatrule-flag-approval">
                              <i className="fa-solid fa-user-check" aria-hidden="true"></i>
                              Needs Approval
                            </span>
                          )}

                          {!!rule.can_override_it_subcategory && (
                            <span className="tatrule-flag-chip tatrule-flag-override">
                              <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                              Can Override IT
                            </span>
                          )}

                          {!rule.requires_change_approval &&
                            !rule.can_override_it_subcategory && (
                              <span className="tatrule-muted">No flags</span>
                            )}

                        </div>

                      </td>

                      <td>

                        <Badge
                          className={`unit-status ${
                            rule.is_active
                              ? "tatrule-status-active"
                              : "tatrule-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              rule.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {rule.is_active ? "Active" : "Inactive"}
                        </Badge>

                      </td>

                      <td>

                        <div className="unit-actions">

                          <Can moduleKey="tat_rules" actionKey="edit">

                            <Button

                              className="unit-icon-btn unit-edit"

                              title="Edit"

                              aria-label={`Edit ${rule.name || "TAT rule"}`}

                              onClick={() => openEdit(rule)}

                            >

                              <i className="fa-solid fa-pen" aria-hidden="true"></i>

                            </Button>

                          </Can>

                          {(can("tat_rules", "activate") || can("tat_rules", "deactivate")) && (

                            <Button

                              className={`unit-icon-btn tatrule-toggle ${
                                rule.is_active
                                  ? "tatrule-toggle-off"
                                  : "tatrule-toggle-on"
                              }`}

                              title={rule.is_active ? "Deactivate" : "Activate"}

                              aria-label={`${rule.is_active ? "Deactivate" : "Activate"} ${rule.name || "TAT rule"}`}

                              onClick={() => toggleStatus(rule)}

                            >

                              <i className={`fa-solid ${rule.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>

                            </Button>

                          )}

                          <Can moduleKey="tat_rules" actionKey="delete">

                            <Button

                              className="unit-icon-btn unit-delete"

                              title="Delete"

                              aria-label={`Delete ${rule.name || "TAT rule"}`}

                              onClick={() => openDeleteModal(rule)}

                            >

                              <i className="fa-solid fa-trash" aria-hidden="true"></i>

                            </Button>

                          </Can>

                        </div>

                      </td>

                    </tr>

                  ))

                ) : (

                  <tr>

                    <td colSpan="8">

                      <div className="unit-empty">

                        <div className="unit-empty-icon">

                          <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>

                        </div>

                        <h5>No TAT rules found</h5>

                        <p>Try another search or add a new rule.</p>

                        <Can moduleKey="tat_rules" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add TAT Rule
                          </Button>
                        </Can>

                      </div>

                    </td>

                  </tr>

                )}

              </tbody>

            </Table>

          )}

        </div>

        <div className="unit-footer">

          <div className="unit-count-text">

            Showing <strong>{rules.length}</strong> of <strong>{total}</strong> rules

          </div>

          {totalPages > 1 && (

            <Pagination className="unit-pagination">

              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />

              {compactPageItems([...Array(totalPages)].map((_, i) => (

                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>

                  {i + 1}

                </Pagination.Item>

              )), currentPage)}

              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />

            </Pagination>

          )}

        </div>

      </div>

      <Can moduleKey="tat_rules" actionKey="preview_resolution">

        <div className="unit-card mt-4 tatrule-preview-card">

          <div className="tatrule-preview-header">

            <div className="tatrule-preview-title">

              <div className="tatrule-preview-icon">
                <i className="fa-solid fa-magnifying-glass-chart" aria-hidden="true"></i>
              </div>

              <div>
                <h5>Resolution Preview</h5>
                <p>Pick a task context and see which rule would apply, its source, and the estimated due date. Read-only — nothing is saved.</p>
              </div>

            </div>

            <span className="tatrule-preview-readonly">
              <i className="fa-solid fa-lock" aria-hidden="true"></i>
              Read only
            </span>

          </div>

          <div className="row g-3 tatrule-preview-form">

            <div className="col-md-3">

              <Form.Label>Task Type</Form.Label>

              <Form.Select value={previewContext.task_type_id} onChange={(e) => setPreviewContext((p) => ({ ...p, task_type_id: e.target.value }))}>

                <option value="">Not set</option>

                {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Priority</Form.Label>

              <Form.Select value={previewContext.priority} onChange={(e) => setPreviewContext((p) => ({ ...p, priority: e.target.value }))}>

                <option value="">Not set</option>

                {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Department</Form.Label>

              <Form.Select value={previewContext.department_id} onChange={(e) => setPreviewContext((p) => ({ ...p, department_id: e.target.value }))}>

                <option value="">Not set</option>

                {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Project</Form.Label>

              <Form.Select

                value={previewContext.project_id}

                onChange={(e) => {

                  setPreviewContext((p) => ({ ...p, project_id: e.target.value, project_module_id: "" }));

                  fetchProjectModules(e.target.value);

                }}

              >

                <option value="">Not set</option>

                {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Project Module</Form.Label>

              <Form.Select

                value={previewContext.project_module_id}

                onChange={(e) => setPreviewContext((p) => ({ ...p, project_module_id: e.target.value }))}

                disabled={loadingScopeTargets || !previewContext.project_id}

              >

                <option value="">Not set</option>

                {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3 d-flex align-items-end">

              <Button className="unit-btn unit-btn-primary w-100" onClick={runPreview} disabled={previewLoading}>

                {previewLoading ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    Resolving...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i>
                    Preview Resolution
                  </>
                )}

              </Button>

            </div>

          </div>

          {previewResult && (

            <div className="tatrule-preview-result">

              {previewResult.source ? (

                <Alert variant="success" className="tatrule-resolution-alert tatrule-resolution-success">
                  <i className="fa-solid fa-circle-check tatrule-resolution-alert-icon" aria-hidden="true"></i>
                  <div>

                  <strong>Source:</strong> {previewResult.source}

                  {previewResult.source_rule_id && <> (rule #{previewResult.source_rule_id})</>}

                  <br />

                  <strong>Applied TAT:</strong> {previewResult.tat_value} {previewResult.tat_unit}

                  <br />

                  <strong>Estimated due date:</strong> {previewResult.due_at}
                  </div>

                </Alert>

              ) : (

                <Alert variant="warning" className="tatrule-resolution-alert tatrule-resolution-warning">
                  <i className="fa-solid fa-triangle-exclamation tatrule-resolution-alert-icon" aria-hidden="true"></i>
                  <div>No TAT rule could be resolved for this context — the task would get no due date.</div>
                </Alert>

              )}

              {Array.isArray(previewResult.explanation) && previewResult.explanation.length > 0 && (

                <div className="tatrule-explanation-card">

                  <div className="tatrule-explanation-title">
                    <i className="fa-solid fa-circle-info" aria-hidden="true"></i>
                    <strong>Why this rule?</strong>
                  </div>

                  <ul className="mb-0">

                    {previewResult.explanation.map((line, i) => <li key={i}><small>{line}</small></li>)}

                  </ul>

                </div>

              )}

            </div>

          )}

        </div>

      </Can>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="tatrule-admin-modal tatrule-admin-modal-lg"
        backdropClassName="tatrule-admin-backdrop"
      >

        <Modal.Header closeButton>

          <div className="tatrule-modal-heading">

            <div className="tatrule-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-stopwatch"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>TAT Rule Setup</small>
              <Modal.Title>{editId ? "Edit TAT Rule" : "Add New TAT Rule"}</Modal.Title>
            </div>

          </div>

        </Modal.Header>

        <Modal.Body>

          <div className="row g-3">

            <div className="col-md-6">

              <Form.Label>Name</Form.Label>

              <div className="tatrule-modal-field">
                <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>

                <Form.Control

                  placeholder="e.g. Project X Fast Track"

                  value={form.name}

                  onChange={(e) => handleChange("name", e.target.value)}

                />
              </div>

            </div>

            <div className="col-md-6">

              <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>

              <div className="tatrule-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>

                <Form.Control

                  placeholder="e.g. PROJECT_X_FAST_TRACK"

                  value={form.code}

                  disabled={!!editId}

                  onChange={(e) => handleChange("code", e.target.value)}

                />
              </div>

            </div>

            <div className="col-md-12">

              <Form.Label>Description</Form.Label>

              <div className="tatrule-modal-field tatrule-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>

                <Form.Control

                  as="textarea"

                  rows={2}

                  value={form.description}

                  onChange={(e) => handleChange("description", e.target.value)}

                />
              </div>

            </div>

            <div className="col-md-4">

              <Form.Label>Scope Type</Form.Label>

              <Form.Select value={form.scope_type} onChange={(e) => handleScopeTypeChange(e.target.value)}>

                {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}

              </Form.Select>

            </div>

            {form.scope_type === "DEPARTMENT" && (

              <div className="col-md-8">

                <Form.Label>Department</Form.Label>

                <Form.Select value={form.department_id} onChange={(e) => handleChange("department_id", e.target.value)}>

                  <option value="">Select department...</option>

                  {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}

                </Form.Select>

              </div>

            )}

            {form.scope_type === "PROJECT" && (

              <div className="col-md-8">

                <Form.Label>Project</Form.Label>

                <Form.Select value={form.project_id} onChange={(e) => handleChange("project_id", e.target.value)}>

                  <option value="">Select project...</option>

                  {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}

                </Form.Select>

              </div>

            )}

            {form.scope_type === "PROJECT_MODULE" && (

              <>

                <div className="col-md-4">

                  <Form.Label>Project</Form.Label>

                  <Form.Select

                    value={form.project_id}

                    onChange={(e) => {

                      handleChange("project_id", e.target.value);

                      handleChange("project_module_id", "");

                      fetchProjectModules(e.target.value);

                    }}

                  >

                    <option value="">Select project...</option>

                    {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}

                  </Form.Select>

                </div>

                <div className="col-md-4">

                  <Form.Label>Module</Form.Label>

                  <Form.Select

                    value={form.project_module_id}

                    onChange={(e) => handleChange("project_module_id", e.target.value)}

                    disabled={loadingScopeTargets || !form.project_id}

                  >

                    <option value="">Select module...</option>

                    {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}

                  </Form.Select>

                </div>

              </>

            )}

            {form.scope_type === "TASK_TYPE_PRIORITY" && (

              <>

                <div className="col-md-4">

                  <Form.Label>Task Type</Form.Label>

                  <Form.Select value={form.task_type_id} onChange={(e) => handleChange("task_type_id", e.target.value)}>

                    <option value="">Select task type...</option>

                    {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}

                  </Form.Select>

                </div>

                <div className="col-md-4">

                  <Form.Label>Priority (optional narrowing)</Form.Label>

                  <Form.Select value={form.priority} onChange={(e) => handleChange("priority", e.target.value)}>

                    <option value="">Applies to all priorities</option>

                    {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}

                  </Form.Select>

                </div>

              </>

            )}

            <div className="col-md-3">

              <Form.Label>TAT Value</Form.Label>

              <Form.Control

                type="number"

                value={form.tat_value}

                onChange={(e) => handleChange("tat_value", e.target.value)}

              />

            </div>

            <div className="col-md-3">

              <Form.Label>TAT Unit</Form.Label>

              <Form.Select value={form.tat_unit} onChange={(e) => handleChange("tat_unit", e.target.value)}>

                {TAT_UNITS.map((u) => <option key={u} value={u}>{u}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Reopen Policy</Form.Label>

              <Form.Select value={form.reopen_policy} onChange={(e) => handleChange("reopen_policy", e.target.value)}>

                {REOPEN_POLICIES.map((p) => <option key={p} value={p}>{p}</option>)}

              </Form.Select>

            </div>

            <div className="col-md-3">

              <Form.Label>Priority (tie-break)</Form.Label>

              <Form.Control

                type="number"

                value={form.priority_order}

                onChange={(e) => handleChange("priority_order", e.target.value)}

              />

            </div>

            <div className="col-md-12">

              <div className="tatrule-config-grid">

                <Form.Check
                  className="tatrule-config-check"
                  type="checkbox"
                  label="Requires approval before a requested TAT change takes effect"
                  checked={form.requires_change_approval}
                  onChange={(e) => handleChange("requires_change_approval", e.target.checked)}
                />

                <Form.Check
                  className="tatrule-config-check tatrule-config-check-warning"
                  type="checkbox"
                  label="Can override the IT-support sub-category TAT baseline"
                  checked={form.can_override_it_subcategory}
                  onChange={(e) => handleChange("can_override_it_subcategory", e.target.checked)}
                />

              </div>

              {form.can_override_it_subcategory && (

                <Form.Text className="tatrule-override-warning">
                  <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                  Warning: this rule will take precedence over the existing IT sub-category TAT for matching IT-support tasks.
                </Form.Text>

              )}

            </div>

          </div>

        </Modal.Body>

        <Modal.Footer>

          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>

            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Rule" : "Create Rule"}
              </>
            )}

          </Button>

        </Modal.Footer>

      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="tatrule-admin-modal tatrule-admin-modal-sm tatrule-admin-modal-danger"
        backdropClassName="tatrule-admin-backdrop"
      >

        <Modal.Header closeButton>

          <div className="tatrule-modal-heading">

            <div className="tatrule-modal-icon tatrule-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete TAT Rule</Modal.Title>
            </div>

          </div>

        </Modal.Header>

        <Modal.Body>

          <div className="tatrule-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-stopwatch"></i>
          </div>

          <p className="unit-delete-text text-center">

            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.

            If tasks or history reference it, deletion will be blocked — deactivate it instead.

          </p>

        </Modal.Body>

        <Modal.Footer>

          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>

        </Modal.Footer>

      </Modal>

    </div>

  );

}
